import { Alert, AlertDescription } from '@/components/ui/alert'

type StandardExtractErrorAlertProps = {
  message: string
}

export function StandardExtractErrorAlert({
  message,
}: StandardExtractErrorAlertProps) {
  return (
    <Alert variant='destructive'>
      <AlertDescription className='text-current'>{message}</AlertDescription>
    </Alert>
  )
}
